export default __webpack_public_path__ + "static/media/drag-and-drop-icon.950c51c3.svg";